var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2132 14.8283C1.5956 13.2662 1.5956 10.7336 3.2132 9.17155C4.8308 7.60948 7.45346 7.60948 9.07106 9.17155L12 11.9999L9.07106 14.8283C7.45346 16.3904 4.8308 16.3904 3.2132 14.8283Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7868 14.8284C22.4044 13.2664 22.4044 10.7338 20.7868 9.1717C19.1692 7.60963 16.5465 7.60963 14.9289 9.1717L12 11.9999L14.9289 14.8284C16.5465 16.3905 19.1692 16.3905 20.7868 14.8284Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.c1214df91a1af53f6489d8b1d78031c3.svg";
export { ForwardRef as ReactComponent };